import React, {Component} from 'react';
import {Grid} from 'material-ui';
import {
    Field,
    reduxForm
} from 'redux-form';
import validate from './validation';
import {InputTextField} from '../../../components/fields/field_input_text';
import {InputHiddenField} from '../../../components/fields/field_input_hidden';
import {InputSelectField} from '../../../components/fields/field_input_select_blocks';
import {BackButton} from '../../../components/buttons/BackButton';
import {SaveButton} from '../../../components/buttons/SaveButton';

class EditForm extends Component {

    render() {
        const {
            label,
            labelTypes,
            handleSubmit,
            pristine,
            loading,
            classes
        } = this.props;

        return (
            <form onSubmit={handleSubmit(this.props.handleFormSubmit)}>
                <div className="heading">
                    <p className="lead">Edit Label <em>"{label.display_name}"</em></p>
                </div>
                <Field name="id" type="hidden" component={InputHiddenField} />
                <Grid container>
                    <Grid item xs={12} md={4}>
                        <Field
                            id="select-label-type"
                            name="label_type_id"
                            label="Select Label Type"
                            component={InputSelectField}
                            options={labelTypes}
                            fullWidth={true}
                            helperText="Please select label type *"
                            className={classes.selectMenuItem}
                        />
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Field name="id" type="hidden" component={InputHiddenField} />
                        <Field
                            name="display_name"
                            component={InputTextField}
                            label="Label name"
                            fullWidth={true}
                            autoFocus={true}
                            InputLabelProps={{
                                required: true,
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12}>
                        <SaveButton
                            type="submit"
                            loading={loading}
                            disabled={pristine || loading}
                            variant="raised"
                            color="primary"
                            className="floatRight"
                        />
                        <BackButton
                            link={"/labels"}
                            style={{marginRight: 15 }}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                </Grid>
            </form>
        )
    }
}

export default reduxForm({
    form: 'LabelEditForm',
    enableReinitialize : true,
    destroyOnUnmount: false,
    validate
})(EditForm);



// WEBPACK FOOTER //
// ./src/containers/labels/forms/EditForm.jsx